<template>
  <div class="cause-wrapper w-100">
    <div class="d-flex">
      <input name="manufacture[cause]" class="form-control flex-1" placeholder="Cause" v-model="cause" />
      <a @click.prevent="$emit('changeValue', cause)" href="#" class="btn btn-outline-success ml-2">
        <span>Submit</span>
      </a>
      <a class="btn btn-outline-light ml-2" @click.prevent="$emit('hiddenVisibility')">
        <span>Cancel</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cause: ''
    }
  }
}
</script>
